/** @format */
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { displayErrorData } from "./DocsManager";

export default function AlertIconButton({ docId, jError }) {
  if (!jError || (typeof jError === "object" && Object.keys(jError).length === 0)) {
    return null;
  }

  const handleOpen = () => {
    const errorData = {
      DocId: docId,
      jError, 
      timestamp: new Date().toISOString(),
    };

    displayErrorData(errorData);
  };

  return (
    <button
      title="Afficher les erreurs"
      className="btn btn-link p-0 d-inline-flex align-items-center justify-content-center"
      onClick={handleOpen}
      style={{
        width: "30px",
        height: "30px",
        color: "#dc3545",
        fontSize: "16px",
      }}
    >
      <FontAwesomeIcon icon={faExclamationTriangle} />
    </button>
  );
}

AlertIconButton.propTypes = {
  docId: PropTypes.string.isRequired,
  jError: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};
